import { motion } from "framer-motion";
import { PrimaryButton, GhostButton } from "../CTA";

const CTASection = () => {
  return (
    <section className="relative overflow-hidden bg-navy py-24 grain sm:py-28" data-testid="cta-section">
      <div className="blueprint-grid absolute inset-0 opacity-40" />
      <div className="spotlight absolute inset-0" />
      <div className="relative mx-auto max-w-[1100px] px-5 text-center sm:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-4xl font-semibold leading-tight tracking-tight text-white sm:text-6xl"
        >
          Let's build your next
          <br />
          <span className="text-brand-soft">precision component.</span>
        </motion.h2>
        <p className="mx-auto mt-6 max-w-xl text-white/60">
          Share your drawings and requirements — our engineering team responds within 24 hours.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <PrimaryButton to="/inquiry" testId="cta-quote-btn" className="!bg-brand hover:!bg-white hover:!text-navy">
            Request a Quote
          </PrimaryButton>
          <GhostButton to="/machinery" dark testId="cta-machinery-btn">Explore Machinery</GhostButton>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
